import React from "react";
import { Card, CardBody } from "reactstrap";
import { ClientInfo } from "../constants";

type ClientDetailsCardProps = {
  client: ClientInfo | null;
};

const ClientDetailsCard: React.FC<ClientDetailsCardProps> = ({ client }) => (
  <Card className="shadow-sm h-100">
    <CardBody>
      <p className="text-muted mb-2">Detalles del cliente</p>
      {client ? (
        <>
          <p className="mb-1">
            <strong>Nombre:</strong> {client.razon_social}
          </p>
          <p className="mb-1">
            <strong>Documento:</strong> {client.documento}
          </p>
          <p className="mb-0">
            <strong>Email:</strong> {client.email || "No informado"}
          </p>
        </>
      ) : (
        <>
          <p className="mb-1">
            <strong>Nombre:</strong> Pendiente de asignar
          </p>
          <p className="mb-1">
            <strong>RUC:</strong> Pendiente
          </p>
          <p className="mb-0">
            <strong>Email:</strong> info@baconapp.com.py
          </p>
        </>
      )}
    </CardBody>
  </Card>
);

export default ClientDetailsCard;
